import type { Definition } from '@exodus/dependency-types';
import MpcClient from '@passkeys/mpc-client';

const mpcClientDefinition = {
  id: 'mpcClient',
  type: 'module',
  factory: () =>
    new MpcClient({
      baseUrl: __MPC_SERVER_URL__,
    }),
  dependencies: [],
} as const satisfies Definition;

export default mpcClientDefinition;
